module.exports = __webpack_public_path__ + "static/media/areas02M.323485fc.jpg";